<template>
  <div class="banner">
    <div class="swiper-container swiper-banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img class="bannerImg" src="../../assets/images/home/home_bg@2x.png" alt="">
          <div class="bannerTitle">
            <p class="title">
              {{$t('home_22')}}
            </p>
          </div>
          <div class="bannerBtn">
            <a class="banner_gp" href="https://play.google.com/store/apps/details?id=com.wtmob.app" target="_blank" style="margin-right: 20px;">
              <img src="../../assets/images/GooglePlay@2x.png" style="width: 180px" alt="">
            </a>
            <a href="https://apps.apple.com/us/app/wetrade-forex-analysis/id6450929145" target="_blank" class="banner_as desImg" style="margin-right: 20px;">
              <img src="../../assets/images/AppStore@2x.png" style="width: 180px" alt="">
            </a>
            <a href="https://webtrader.wetrade.one" target="blank" class="webplate banner_web">
              <img src="../../assets/images/web_icon.png" alt="">
              <div class="webplate-inline">
                <div class="webplate-t">{{$t('home_23')}}</div>
                <div class="webplate-b">{{$t('home_24')}}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
    import Swiper from 'swiper/bundle'
    import 'swiper/swiper-bundle.css'
    export default {
      name: "banner",
      data(){
        return{
        }
      },
      methods: {
        googlePay(){
          window.open('https://play.google.com/store/apps/details?id=com.wtmob.app')
        },
        appleStore(){
          window.open('https://apps.apple.com/us/app/wetrade-forex-analysis/id6450929145')
        },
        webPlatform(){
          window.open('https://webtrader.wetrade.one/')
        }
      },
      mounted () {
        const mySwiper = new Swiper('.swiper-banner', {
          direction: 'horizontal', // 垂直切换选项 vertical
          loop: true, // 循环模式选项
          spaceBetween: 0,
          enabled: false,
          // autoplay: {
          //   delay: 3000,
          //   disableOnInteraction: false,
          // },
          // 如果需要分页器
          clickable: this.pagination,
          // pagination: {
          //   el: '.swiper-pagination',
          //   clickable: true,
          // },
        })
      },
    }
</script>

<style lang="scss">
  .banner {
    .bannerTitle, .bannerBtn {
      position: absolute;
      left: 0;
      right: 0;
      text-align: center;
      img{
        cursor: pointer;
      }
    }
    .bannerTitle {
      top: 30%;
      font-size: 40px;
      color: #FFFFFF;
      .title {
        width: 700px;
        margin: auto;
        font-family: Poppins;
      }
    }

    .bannerBtn {
      bottom: 5%;
      display: flex;
      justify-content: center;
      .webplate{
        text-decoration: none;
        width: 380px;
        height: 60px;
        display: flex;
        align-items: center;
        background: linear-gradient(270deg, #FF004E 0%, #FF694C 100%);
        border-radius: 30px;
        cursor: pointer;
        padding:0 20px;
        img{
          width: 34px;
          height: 34px;
        }
        .webplate-inline{
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex: 1;
          white-space: nowrap;
        }
        .webplate-t{
          font-size: 22px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 25px;
          margin-left: 15px;
        }
        .webplate-b{
          height: 40px;
          background: #FFE656;
          border-radius: 21px;
          font-size: 20px;
          padding: 0 15px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #000000;
          line-height: 24px;
          line-height: 40px;
          margin-left: 15px;
          max-width: 150px;
        }
      }
    }

    .bannerImg {
      width: 100%;
    }
  }
  .swiper-slide {
    display: block;
    outline: none;
  }

  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    opacity: 1;
    background: rgba(0, 0, 0, 0.2);
  }

  .swiper-pagination-bullet-active {
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/TheBanner.vue